// import { useQuery, useMutation } from 'react-query'
import { useLazyQuery, useMutation, useQuery } from '@apollo/client'
import { CREATE_REPORT, GET_REPORT_URL, LIST_LAST_REPORTS, PAGINATE_REPORTS } from '../queries/reportQueries'
import { useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import { reportCreator } from 'state'

const usePaginateReports = () => {
    const dispatch = useDispatch();
    const { paginateReports } = bindActionCreators(reportCreator, dispatch)

    return useQuery(PAGINATE_REPORTS, {
        onCompleted: (data: any) => {
            paginateReports(data.paginateReports);
        }
    });
};

const useLazyPaginateReports = () => {
    const dispatch = useDispatch();
    const { paginateReports } = bindActionCreators(reportCreator, dispatch)

    return useLazyQuery(PAGINATE_REPORTS, {
        onCompleted: (data: any) => {
            paginateReports(data.paginateReports);
        }
    });
};

const useGetLastReports = () => {
    const dispatch = useDispatch();
    const { listLastReports } = bindActionCreators(reportCreator, dispatch)

    return useQuery(LIST_LAST_REPORTS, {
        onCompleted: (data: any) => {
            listLastReports(data.listLastReports);
        }
    });
};

const useCreateReport = ({ onSuccess, onError }: any) => {
    const dispatch = useDispatch();
    const { createReport } = bindActionCreators(reportCreator, dispatch)

    return useMutation(CREATE_REPORT, {
        onCompleted: (data: any) => {
            createReport(data.createReport);
            onSuccess();
        },
        onError: () => {
            onError();
        }
    });
}

 const useGetReport = () => {
    return useLazyQuery(GET_REPORT_URL);
} 

const useUpdateReport = (id: string, options = {}) => {
    // const dispatch = useDispatch()
    // const { createReport } = bindActionCreators(reportCreators, dispatch)

    // return useMutation(['updateReport'], (data) => putReport(id, data), {
    //     onSuccess: (data) => {
    //         createReport(data)
    //     },
    //     onError: (error) => {
            
    //     }
    // })
}

export {
    usePaginateReports,
    useLazyPaginateReports,
    useGetLastReports,
    useCreateReport,
    useGetReport,
}